import { render, staticRenderFns } from "./UtilImage.vue?vue&type=template&id=3b0d96a6&scoped=true&"
import script from "./UtilImage.vue?vue&type=script&lang=js&"
export * from "./UtilImage.vue?vue&type=script&lang=js&"
import style0 from "./UtilImage.vue?vue&type=style&index=0&id=3b0d96a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d96a6",
  null
  
)

export default component.exports